
import { defineComponent, ref } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useRouter } from "vue-router";
import Tooltip from "@/components/wizard/steps-tooltip/Tooltip5.vue";

export default defineComponent({
  name: "step-5",
  components: {
    Field,
    ErrorMessage,
    Tooltip,
  },
  setup() {
    const router = useRouter();
    let info_onboarding_msg = ref(false);
    let info_home_msg = ref(false);

    if (router.currentRoute.value.path == "/onboarding") {
      info_onboarding_msg.value = true;
    } else if (router.currentRoute.value.path == "/home") {
      info_home_msg.value = true;
    }

    return {
      info_onboarding_msg,
      info_home_msg,
    };
  },
});
